var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M6.225 1.55313C6.39375 1.2125 6.74062 1 7.11875 1H10.8813C11.2594 1 11.6062 1.2125 11.775 1.55313L12 2H15C15.5531 2 16 2.44687 16 3C16 3.55312 15.5531 4 15 4H3C2.44687 4 2 3.55312 2 3C2 2.44687 2.44687 2 3 2H6L6.225 1.55313ZM3 5H15V15C15 16.1031 14.1031 17 13 17H5C3.89688 17 3 16.1031 3 15V5ZM6 7C5.725 7 5.5 7.225 5.5 7.5V14.5C5.5 14.775 5.725 15 6 15C6.275 15 6.5 14.775 6.5 14.5V7.5C6.5 7.225 6.275 7 6 7ZM9 7C8.725 7 8.5 7.225 8.5 7.5V14.5C8.5 14.775 8.725 15 9 15C9.275 15 9.5 14.775 9.5 14.5V7.5C9.5 7.225 9.275 7 9 7ZM12 7C11.725 7 11.5 7.225 11.5 7.5V14.5C11.5 14.775 11.725 15 12 15C12.275 15 12.5 14.775 12.5 14.5V7.5C12.5 7.225 12.275 7 12 7Z",
          fill: "black",
          "fill-opacity": "0.45",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }